import React from 'react';

export default function Home() {
  return (
    <div className="home-page">
      <div className="bgimg w3-display-container w3-animate-opacity w3-text-white">
        <div className="w3-display-middle">
          <h1 className="w3-jumbo">WELCOME TO BOOKKERS</h1>
        </div>
      </div>
      <img alt="" src="https://wallpapercave.com/wp/wp2036897.jpg" />
    </div>
  );
}
